import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";

const initialState = {
  loading: false,
  TrainingFilter: [],
  FeedbackFilter: [],
  error: false,
  showFilter: true,
};

const AllPageFilter = createSlice({
  name: "AllPageFilter",
  initialState,
  reducers: {
    filterList: (state, action) => {
      console.log("showFilter:::::", action.payload);
      state.showFilter = action.payload;
    },
    TrainingListingPageFilter: (state, action) => {
      console.log("All page filter state: ", {
        ...state.TrainingFilter,
        ...action.payload,
      });
      state.TrainingFilter = { ...state.TrainingFilter, ...action.payload };
      state.loading = false;
      state.error = false;
    },
    FeedbackListingPageFilter: (state, action) => {
      state.FeedbackFilter = { ...state.FeedbackFilter, ...action.payload };
      state.loading = false;
      state.error = false;
    },
  },
});
export const {
  TrainingListingPageFilter,
  FeedbackListingPageFilter,
  filterList,
} = AllPageFilter.actions;
export default AllPageFilter.reducer;
